import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {toJS} from 'mobx'
import {observer, inject} from 'mobx-react'
import ViabilityTool from '../components/ViabilityTool'

class ViabilityContainer extends Component {
    onAddCostRow(row){
        // console.log('onAddCostRow',row)
        if(!this.props.stores.store.theIdea.costRows){
            this.props.stores.store.theIdea.costRows = []
        }
        let newRows = toJS(this.props.stores.store.theIdea.costRows)
        newRows.push(row)
        this.props.stores.store.theIdea.costRows = newRows 
        this.props.stores.store.updateIdeaProp(
            this.props.ideaKey, 
            'costRows', 
            this.props.stores.store.theIdea.costRows,
        )
    }
    onEditCostRow(row){
        // console.log('onEditCostRow',row)        
        let rows = toJS(this.props.stores.store.theIdea.costRows)
        for(let i in rows){
            if(rows[i].id === row.id){
                rows[i]=row
            }
        }
        this.props.stores.store.theIdea.costRows = rows 
        this.props.stores.store.updateIdeaProp(
            this.props.ideaKey, 
            'costRows', 
            this.props.stores.store.theIdea.costRows,
        )
    }
    onDeleteCostRow(rowKeys){
        // console.log('onDeleteCostRow',rowKeys)
        let rows = toJS(this.props.stores.store.theIdea.costRows)
        for(let j in rowKeys){
            for(let i in rows){
                if(rows[i].id === rowKeys[j]){
                    rows.splice(i, 1) //remove element
                }
            }
        }
        this.props.stores.store.theIdea.costRows = rows 
        this.props.stores.store.updateIdeaProp(
            this.props.ideaKey, 
            'costRows', 
            this.props.stores.store.theIdea.costRows,
        )
    }
    onAddRevenueRow(row){
        // console.log('onAddRevenueRow',row)        
        if(!this.props.stores.store.theIdea.revenueRows){
            this.props.stores.store.theIdea.revenueRows = []
        }
        let newRows = toJS(this.props.stores.store.theIdea.revenueRows)
        newRows.push(row)
        this.props.stores.store.theIdea.revenueRows = newRows 
        this.props.stores.store.updateIdeaProp(
            this.props.ideaKey, 
            'revenueRows', 
            this.props.stores.store.theIdea.revenueRows,
        )
    }
    onEditRevenueRow(row){
        // console.log('onEditRevenueRow',row)        
        let rows = toJS(this.props.stores.store.theIdea.revenueRows)
        for(let i in rows){
            if(rows[i].id === row.id){
                rows[i]=row
            }
        }
        this.props.stores.store.theIdea.revenueRows = rows 
        this.props.stores.store.updateIdeaProp(
            this.props.ideaKey, 
            'revenueRows', 
            this.props.stores.store.theIdea.revenueRows,
        )
    }
    onDeleteRevenueRow(rowKeys){
        // console.log('onDeleteRevenueRow',rowKeys)
        let rows = toJS(this.props.stores.store.theIdea.revenueRows)
        for(let j in rowKeys){
            for(let i in rows){
                // let theRows = rows.slice() //copy array
                if(rows[i].id === rowKeys[j]){
                    rows.splice(i, 1) //remove element
                }
            }
        }
        this.props.stores.store.theIdea.revenueRows = rows 
        this.props.stores.store.updateIdeaProp(
            this.props.ideaKey, 
            'revenueRows', 
            this.props.stores.store.theIdea.revenueRows,
        )
    }
    onViabilityTextChange(text){  
        this.props.stores.store.updateIdeaProp(
            this.props.ideaKey, 
            'viabilityText', 
            text,
        ) 
    }    
    render(){
        const {stores} = this.props
        const {store} = stores
        const {theIdea} = store
        return(
            <ViabilityTool 
                costRows={toJS(theIdea.costRows)}
                revenueRows={toJS(theIdea.revenueRows)}
                viabilityText={theIdea.viabilityText}
                onAddCostRow={this.onAddCostRow.bind(this)}
                onEditCostRow={this.onEditCostRow.bind(this)}
                onDeleteCostRow={this.onDeleteCostRow.bind(this)}
                onAddRevenueRow={this.onAddRevenueRow.bind(this)}
                onEditRevenueRow={this.onEditRevenueRow.bind(this)}
                onDeleteRevenueRow={this.onDeleteRevenueRow.bind(this)}
                onTextChange={this.onViabilityTextChange.bind(this)}
            />
        )
    }
}
ViabilityContainer.propTypes = {
    ideaKey: PropTypes.string.isRequired,
}
ViabilityContainer.defaultProps = {
    ideaKey: '',
}
export default inject("stores")(observer(ViabilityContainer))



// WEBPACK FOOTER //
// ./src/containers/ViabilityContainer.js